// import { sanitise } from "./sanitise.util";
// function renderArray(arr, property = null, tag = null) {
//     return arr.map(item => {
//         if (typeof item === 'object' && !Array.isArray(item)) {
//             // If it's an object and you want to display the specific property or full object values
//             let content = property ? item[property] : Object.values(item).join(', ');
//             if (property === 'standard') {
//                 // If the item is a standard, display it as a badge
//                 return `<span class="badge">${tag ? `${tag}-${sanitise(content)}` : sanitise(content)}</span>`;
//             }
//             return `<a class="hover-info" href="#">${tag ? `${tag}-${sanitise(content)}` : sanitise(content)}</a>`;
//         }

//         if (property === 'standard') {
//             // If the item is a standard, display it as a badge
//             return `<span class="badge">${tag && !sanitise(item).includes(tag) ? `${tag}-${sanitise(item)}` : sanitise(item) }</span>`;
//         }
//         // If it's a primitive value (string, number, etc.), just display it directly
//         return `<a class="hover-info" href="#">${tag && !sanitise(item).includes(tag) ? `${tag}-${sanitise(item) }` : sanitise(item) }</a>`;
//     }).join(property === 'standard' ? ' ' : ', '); // Separate each <a> tag by a comma and a space
// }

// export const parseIssueRegisterRows = (issue, index, expanded = false) => {
//     const issueType = issue.type;
//     const name = issue.name;
//     const description = issue.description;
//     const issueDetails = issue.details;

//     return `
//     <tr class="tableordion-row" data-issue-id="${issue.id}">
//         <td>${sanitise(issueType)}</td>
//         <td>${sanitise(name)}</td>
//         <td>${sanitise(description)}</td>
//         <td class="action-buttons">
//             <button class="action-btn" onclick="openEditIssueModal(this)" data-issueID="${issue.id}">
//                 <i class="fa-duotone fa-pencil edit-icon" alt="Edit"></i>
//             </button>
//             <button class="action-btn collapse-toggle" data-toggle="${expanded ? 'collapse' : 'expand'}">
//                 <i class="fa-duotone fa-solid fa-square-chevron-${expanded ? 'up' : 'down'}" style="color: ${expanded ? '#F6961D' : '#585555'};"></i>
//             </button>
//         </td>
//     </tr>
//     <tr class="tableordion-content ${expanded ? 'accordion-content-active' : 'hidden'}" data-issue-id="${issue.id}" style="display: ${expanded ? 'table-row' : 'none'};">
//         <td colspan="4">
//             <div class="accordion-inner-content">
//                 <table>
//                     <thead>
//                         <tr class="tableordion-header">
//                             <th>Issue Type</th>
//                             <th>Risks</th>
//                             <th>Objectives</th>
//                             <th>Legal Obligations</th>
//                             <th>Framework</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         <tr>
//                             <td>${sanitise(issueDetails.issueType)}</td>
//                             <td>${renderArray(issueDetails.risks, 'riskID', 'RSK')}</td>
//                             <td>${renderArray(issueDetails.objectives, 'id', 'OBJ')}</td>
//                             <td>${renderArray(issueDetails.legalObligations, 'id', 'LEO')}</td>
//                             <td><div class="badges">${renderArray(issueDetails.frameworks, 'standard')}</div></td>
//                         </tr>
//                     </tbody>
//                 </table>
//             </div>
//         </td>
//     </tr>`;
// };


import { sanitise } from "./sanitise.util";
function renderArray(arr, property = null, tag = null) {
    let link = "#";
    if (tag !== null) {
        if (tag === "RSK") {
            link = window.location.origin + "/riskregister";
        } else if (tag === "OBJ") {
            link = window.location.origin + "/managementSystemGuide#!/MSG/planning/objectives";
        } else if (tag === "LEO") {
            link = window.location.origin + "/managementSystemGuide#!/MSG/context/legalObligations";
        }
    }

    return arr.map(item => {
        if (typeof item === 'object' && !Array.isArray(item)) {
            // If it's an object and you want to display the specific property or full object values
            let content = property ? item[property] : Object.values(item).join(', ');
            if (property === 'standard') {
                // If the item is a standard, display it as a badge
                return `<span class="badge">${tag ? `${tag}-${sanitise(content)}` : sanitise(content)}</span>`;
            }

            return `<a class="hover-info" href="${link}?id=${sanitise(content)}">${tag ? `${tag}-${sanitise(content)}` : sanitise(content)}</a>`;
        }

        if (property === 'standard') {
            // If the item is a standard, display it as a badge
            return `<span class="badge">${tag && !sanitise(item).includes(tag) ? `${tag}-${sanitise(item)}` : sanitise(item)}</span>`;
        }

        // If it's a primitive value (string, number, etc.), just display it directly
        return `<a class="hover-info" href="${link}id=${sanitise(item)}">${tag && !sanitise(item).includes(tag) ? `${tag}-${sanitise(item)}` : sanitise(item)}</a>`;
    }).join(property === 'standard' ? ' ' : ', '); // Separate each <a> tag by a comma and a space
}

export const parseIssueRegisterRows = (issue, index, expanded = false) => {
    const issueType = issue.type;
    const name = issue.name;
    const description = issue.description;
    const issueDetails = issue.details;

    return `
    <tr class="tableordion-row" data-issue-id="${issue.id}">
        <td>${sanitise(issueType)}</td>
        <td>${sanitise(name)}</td>
        <td>${sanitise(description)}</td>
        <td class="action-buttons">
            <button class="action-btn" onclick="openEditIssueModal(this)" data-issueID="${issue.id}">
                <i class="fa-duotone fa-solid fa-pencil edit-icon" alt="Edit"></i>
            </button>
            <button class="action-btn deleteBtn" onclick="deleteIssueHandler(event, '${issue.id}')">
                <i class="fa-duotone fa-trash delete-icon color-red" alt="Delete"></i>
            </button>
            <button class="action-btn collapse-toggle" data-toggle="${expanded ? 'collapse' : 'expand'}">
                <i class="fa-duotone fa-solid fa-square-chevron-${expanded ? 'up' : 'down'}" style="color: ${expanded ? '#F6961D' : '#585555'};"></i>
            </button>
        </td>
    </tr>
    <tr class="tableordion-content ${expanded ? 'accordion-content-active' : 'hidden'}" data-issue-id="${issue.id}" style="display: ${expanded ? 'table-row' : 'none'};">
        <td colspan="4">
            <div class="accordion-inner-content">
                <table>
                    <thead>
                        <tr class="tableordion-header">
                            <th>Issue Type</th>
                            <th>Risks</th>
                            <th>Objectives</th>
                            <th>Legal Obligations</th>
                            <th>Framework</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>${sanitise(issueDetails.issueType)}</td>
                            <td>${renderArray(issueDetails.risks, 'riskID', 'RSK')}</td>
                            <td>${renderArray(issueDetails.objectives, 'id', 'OBJ')}</td>
                            <td>${renderArray(issueDetails.legalObligations, 'id', 'LEO')}</td>
                            <td><div class="badges">${renderArray(issueDetails.frameworks, 'standard')}</div></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </td>
    </tr>`;
};